import React, { useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
import { ModuleId } from '../../types';
import { ModuleCheatSheetContent } from './ModuleCheatSheetContent';
interface CheatSheetDrawerProps {
  isOpen: boolean;
  onClose: () => void;
  moduleId: ModuleId;
}
export function CheatSheetDrawer({
  isOpen,
  onClose,
  moduleId
}: CheatSheetDrawerProps) {
  // Accessibility: Escape key to close
  useEffect(() => {
    const handleEscape = (e: KeyboardEvent) => {
      if (e.key === 'Escape' && isOpen) {
        onClose();
      }
    };
    window.addEventListener('keydown', handleEscape);
    return () => window.removeEventListener('keydown', handleEscape);
  }, [isOpen, onClose]);
  return <AnimatePresence data-id="element-542">
      {isOpen && <>
          {/* Backdrop */}
          <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} onClick={onClose} className="fixed inset-0 bg-black/50 z-40" data-id="element-543" />

          {/* Drawer */}
          <motion.div initial={{
        x: '100%'
      }} animate={{
        x: 0
      }} exit={{
        x: '100%'
      }} transition={{
        type: 'spring',
        damping: 25,
        stiffness: 200
      }} className="fixed right-0 top-0 bottom-0 w-full max-w-md bg-white shadow-2xl z-50 overflow-y-auto" data-id="element-544">
            <div className="sticky top-0 bg-white border-b border-slate-200 p-4 flex justify-between items-center z-10 shadow-sm" data-id="element-545">
              <h2 className="text-lg font-bold text-slate-900" data-id="element-546">
                📚 Spiekbriefje
              </h2>
              <button onClick={onClose} className="p-2 hover:bg-slate-100 rounded-lg transition-colors" aria-label="Sluiten" data-id="element-547">
                <X className="w-5 h-5" data-id="element-548" />
              </button>
            </div>

            <div className="p-6" data-id="element-549">
              <ModuleCheatSheetContent moduleId={moduleId} data-id="element-550" />
            </div>

            <div className="sticky bottom-0 bg-white border-t border-slate-200 p-4 shadow-lg" data-id="element-551">
              <button onClick={onClose} className="w-full py-3 bg-indigo-600 text-white rounded-xl font-bold hover:bg-indigo-700 transition-colors shadow-md" data-id="element-552">
                Ik ben klaar! 🚀
              </button>
            </div>
          </motion.div>
        </>}
    </AnimatePresence>;
}